import React from 'react';
import Highlight from './Highlight';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Highlight />
      <S.Content className="first">
        <S.Text>
          <p className="drop-caps">
            Quando alguma palavra ou expressão é usada a torto e a direito, é
            comum seu significado se esvaziar, se perder. Foi o que aconteceu
            com o conceito de streetwear. Hoje, é praticamente impossível
            definir do que se trata. Tem até gente evitando se associar ao
            termo, acha que é reducionismo, que não diz nada ou não faz sentido.
            E talvez não faça mesmo. Pelo menos não tanto quanto fazia para
            Willi Smith, estilista estadunidense que soube definir e traduzir da
            forma mais precisa o que o tal traje das ruas é ou deveria ser.
          </p>
          <p>
            Mas vamos por partes, começando com as devidas apresentações. Willi
            Smith foi um dos estilistas mais bem-sucedidos da moda feita nos
            Estados Unidos. E aqui vale um parênteses importante: ele era negro,
            gay e bastante jovem. Ou seja, a probabilidade de tamanho e tão
            rápido sucesso era bem escassa. Em 1987, pouco mais de dez anos
            depois do lançamento da sua marca, a WilliWear, ele já acumulava
            cerca de 25 milhões de dólares em vendas anuais. Naquele mesmo ano,
            contudo, seu fundador morreu por complicações do HIV.
          </p>
          <p>
            Willi foi o indicado mais jovem ao Coty Awards, premiação que deu
            origem ao CFDA Awards. Sua primeira vitória como melhor designer
            veio em 1983, sua quinta indicação, com a coleção de inverno 1983,
            chamada de Street Couture. O desfile, sempre algo performático,
            trazia uma série de conjuntos de alfaiataria e sarja, inspirados em
            roupas de operários fabris, básicos de qualquer guarda-roupa, no
            estilo hip-hop, e elementos mais sofisticados, tipo aqueles usados
            por membros da comunidade negra nas missas de domingo.
          </p>
        </S.Text>
      </S.Content>
      <S.ImageWrapper>
        <S.Photo1 />
      </S.ImageWrapper>
      <S.PhotoLegend>
        A modelo Toukie Smith e seu irmão, Willi Smith | Foto: Getty Images
      </S.PhotoLegend>
      <S.Content>
        <S.Text>
          <p>
            Uma de suas frases mais famosas, aliás, é a seguinte: “Ser preto tem
            muito a ver com eu ser um bom estilista. A maioria dos designers que
            precisa correr para Paris em busca de combinações de cor e tecidos
            deveria ir à igreja num domingo, no Harlem. Está tudo lá”. Tem
            também aquela que ele diz não fazer roupa para a rainha, “mas para
            as pessoas que acenam para ela na rua”.
          </p>
          <p>
            Willi Smith nasceu na Filadélfia, em 1948. Ávido leitor e
            extremamente criativo, teve pleno apoio e incentivo dos pais no
            desenvolvimento de seu lado artístico. Com ajuda da avó Gladys
            Busch, conseguiu um estágio com o costureiro Arnold Scaasi, em Nova
            York (ela trabalhou como faxineira na casa de clientes do
            estilista). Assim, em 1965, ele se mudou para Nova York. No ateliê
            do designer canadense radicado nos EUA, ele aprendeu mais sobre
            corte, tecidos e costura – e também sobre quem ele não queria
            vestir, a elite estadunidense.
          </p>
          <p>
            Graças ao estágio, conseguiu duas bolsas para estudar moda na
            Parsons School of Design. Porém foi expulso após dois anos, devido a
            um suposto relacionamento romântico com outro aluno. O tempo na
            escola, contudo, o colocou em contato com alguns artistas
            responsáveis pelo boom da cena cultural do Soho nova-iorquino nos
            anos 1970. A partir de então, Willi nunca se distanciou das artes
            plásticas, estabelecendo uma série de parcerias (de moda ou não) com
            nomes importantes, como Christo e Jeanne-Claude, Basquiat e Keith
            Haring.
          </p>
        </S.Text>
      </S.Content>
      <S.PhotoGrid>
        <S.PhotoGrid1 />
        <S.PhotoGrid2 />
        <S.PhotoGrid3 />
        <S.PhotoGrid4 />
      </S.PhotoGrid>
      <S.PhotoLegend>
        Croquis da coleção inverno 1983 | Fotos: Cortesia Willi Smith Archive
      </S.PhotoLegend>
      <S.Content>
        <S.Text>
          <p>
            Depois que deixou a faculdade, o estilista foi trabalhar para
            algumas das marcas da Sétima Avenida, um importante reduto de moda
            em Nova York. Um de seus empregos mais expressivos foi na marca
            Digits, em que deu início à sua paixão por traduzir a roupa do dia a
            dia com ares de luxo e em interpretações mais criativas. No fim da
            década de 1970, tentou lançar uma marca homônima, mas, com a
            economia estadunidense em colapso, o negócio não foi para a frente e
            Willi acabou perdendo o direito de usar o próprio nome.
          </p>
          <p>
            Na época, sua assistente, Laurie Mallet, estava realizando projetos
            pessoais na Índia e o convidou para passar um tempo por lá. A dupla
            voltou como uma pequena coleção de roupas inspiradas nos uniformes
            de policiais indianos e logo a colocou à venda. Uma calça em
            particular, uma cargo com cintura ajustável, virou um verdadeiro hit
            e assim nasceu a Williwear.
          </p>
        </S.Text>
      </S.Content>
      <S.ImageWrapper>
        <S.Photo2 />
        <S.Photo3 />
      </S.ImageWrapper>
      <S.PhotoLegend>
        Looks da coleção inverno 1983 | Fotos: Max Vadukul / Cortesia Willi
        Smith Archive
      </S.PhotoLegend>
      <S.Content>
        <S.Text>
          <p>
            Willi Smith ficou conhecido por olhar para as ruas em busca de
            inspiração e colocar tudo aquilo na passarela. No fim dos anos 1970
            e durante os 80, era um movimento raro, ainda que não exatamente
            novo. Hoje, é quase que via de regra. A diferença é que o estilista
            não o fazia de maneira exploratória, dando roupagem de luxo ou
            destinando aquelas criações para pessoas que raramente caminham
            pelas ruas ou usam o transporte público.{' '}
          </p>
        </S.Text>
      </S.Content>
      <S.ImageWrapper>
        <S.Photo4 />
        <S.Photo5 />
      </S.ImageWrapper>
      <S.PhotoLegend>
        Looks da coleção inverno 1983 | Fotos: Max Vadukul / Cortesia Willi
        Smith Archive
      </S.PhotoLegend>
      <S.Content>
        <S.Text>
          <p>
            A street couture da Williwear era uma verdadeira celebração e
            reconhecimento de um estilo único. Era também destinada às mesmas
            pessoas que o inspiraram. Além de acessíveis, suas roupas eram
            práticas, fáceis de usar e adaptáveis a diversas situações. Tudo
            isso com acabamento e qualidade não muito diferentes de nomes que se
            vendiam como de luxo. “A moda é uma coisa das pessoas e os
            estilistas deveriam se lembrar disso”, disse Willi. “Modelos posam
            com as roupas. As pessoas vivem nelas.”
          </p>
        </S.Text>
      </S.Content>
      <S.Footer>
        <S.Text>
          <p>
            Raio-X de um desfile é a uma seção fixa da ELLE View, em que todos
            os meses examinamos uma apresentação recente, trazendo detalhes
            sobre as roupas e explicando por que vale a pena você saber mais
            sobre ela.
          </p>
        </S.Text>
      </S.Footer>
    </S.Container>
  );
};

export { Main };
